import * as React from "react";
import * as moment from "moment";
import {Pagination} from 'react-bootstrap';
import {RouterView, LoadingViewState} from "../../RouterView";
import {kernel} from "../../../../ioc/IOCHelper";
import {
    BlackjackHandHistoryListRequest,
    BlackjackHandHistoryListResponse,
    BlackjackHandHistoryService,
    Game,
    Hand
} from "../../../../service/blackjack/history/BlackjackHandHistoryService";
import {Symbols} from "../../../../ioc/Symbols";
import {FormListener, Form} from "../../../form/Form";
import {FormGroup} from "../../../form/FormGroup";
import {FormInput} from "../../../form/FormInput";
import {CustomTable} from "../../../util/CustimizableTable";
import {FormDateTimePicker} from "../../../form/FormDateTimePicker";
import {SelectInput} from "../../../form/SelectInput";
import {Validators} from "../../../form/Validators";


interface State extends LoadingViewState {
    request?: BlackjackHandHistoryListRequest;
    games?: Game[];
    totalResults?: number;
    limit?: number;
    validationMap?: any;
    searching?: boolean;
    gameId?: string;
    activePage?: number;
}

interface Props {
}

export class BlackjackHandHistoryListView extends RouterView<Props, State> implements FormListener<BlackjackHandHistoryListRequest> {
    service: BlackjackHandHistoryService;

    constructor(props: Props) {
        super(props);
        this.state = Object.assign(this.state, {
            gameId: "",
            totalResults: 0,
            validationMap: {},
            games: [],
            activePage: 1,
            limit: 1,
        });

        this.service = kernel.get<BlackjackHandHistoryService>(Symbols.BlackjackHandHistoryService);
    }

    loadContent(): Promise<any> | void {
        return;
    }

    onSubmit() {
        this.setState({activePage: 1});
        this.search(this.state.request);
    }

    search(request) {
        this.setState({searching: true, request: request});
        this.service.listHandHistory(request).then((res: BlackjackHandHistoryListResponse) => {
            this.setState({games: res.hands, totalResults: res.totalResults, limit: res.limit, searching: false});
        }).catch(() => {
            this.setState({searching: false, totalResults: 0});
        });
    }

    getSingleHand() {
        this.service.getHand(this.state.gameId.trim()).then((res: Game) => {
            this.setState({games: [res], searching: false, totalResults: 1, limit: 1});
        }).catch(() => {
            this.setState({searching: false, totalResults: 0});
        });
    }

    formDidUpdate(formModel: BlackjackHandHistoryListRequest, validationMap?: any) {
        this.setState({request: formModel, validationMap: validationMap});
    }

    handleChange(event: React.FormEvent) {
        const value = (event.target as any).value;
        this.setState({gameId: value});
    }

    getPageCount(): number {
        return Math.ceil(this.state.totalResults / this.state.limit);
    }

    handlePageSelect(eventKey) {
        let req = this.state.request;
        req.offset = this.state.limit * (eventKey - 1);
        this.setState({activePage: eventKey});
        this.search(req);
    }

    getPagination(): JSX.Element {
        if (!this.state.games.length) return;
        return (
            <Pagination
                prev="Previous"
                next="Next"
                items={this.getPageCount()}
                activePage={this.state.activePage}
                onSelect={this.handlePageSelect.bind(this)}/>
        );
    }

    renderContent(): JSX.Element {
        return (
            <div>
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col-lg-12">
                        <h1>Blackjack Hand History</h1>
                    </div>

                </div>
                <div className="wrapper wrapper-content animated">
                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                            <h5>Find Game</h5>
                        </div>
                        <div className="ibox-content">
                            <div className="form-horizontal row">
                                <div className="form-group">
                                    <label className="col-lg-2 control-label">Game ID</label>
                                    <div className="col-lg-10">
                                        <input type="text" className="form-control"
                                               onChange={this.handleChange.bind(this)} value={this.state.gameId}/>
                                        <span className="help-block m-b-none">The unique ID of the game you are looking for</span>
                                    </div>
                                </div>
                                <div className="col-lg-offset-2 col-lg-10">
                                    <input className="btn btn-primary" value="Show Hand" type="submit"
                                           onClick={() => {
                                               this.getSingleHand()
                                           }}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="ibox float-e-margins" style={{
                        opacity: this.state.searching ? 0.5 : 1,
                        pointerEvents: this.state.searching ? "none" : "auto"
                    }}>
                        <div className="ibox-title">
                            <h5>Find Games</h5>
                        </div>
                        <div className="ibox-content">
                            <Form className="form-horizontal" formListener={this} modelObject={this.state.request}
                                  validationMap={this.state.validationMap}>
                                <FormGroup className="form-group" model="startTime">
                                    <label className="col-lg-2 control-label">From Date (UTC):</label>
                                    <div className="col-lg-10">
                                        <FormDateTimePicker timeZoneId="UTC" model="startTime"
                                                            validators={[Validators.required()]}/>
                                        <span className="help-block m-b-none">Show games from this date</span>
                                    </div>
                                </FormGroup>
                                <FormGroup className="form-group" model="endTime">
                                    <label className="col-lg-2 control-label">To Date (UTC):</label>
                                    <div className="col-lg-10">
                                        <FormDateTimePicker timeZoneId="UTC" model="endTime"
                                                            validators={[Validators.required()]}/>
                                        <span className="help-block m-b-none">Show hands up to this date</span>
                                    </div>
                                </FormGroup>
                                <FormGroup className="form-group" model="currencyCode">
                                    <label className="col-lg-2 control-label">Currency:</label>
                                    <div className="col-lg-10">
                                        <SelectInput className="form-control" model="currency" values={["GC", "SC"]}/>
                                        <span className="help-block m-b-none">Table currency</span>
                                    </div>
                                </FormGroup>
                                <FormGroup className="form-group" model="userId">
                                    <label className="col-lg-2 control-label">User Id:</label>
                                    <div className="col-lg-10">
                                        <FormInput className="form-control" model="userId" type="text"
                                                   validators={[Validators.required(), Validators.integer()]}/>
                                        <span className="help-block m-b-none">User ID of the player (NOT Cubeia Id)</span>
                                    </div>
                                </FormGroup>
                                <div className="form-group">
                                    <div className="col-lg-offset-2 col-lg-10 pager-buttons">
                                        <input className="btn btn-primary" value="Apply" type="submit"/>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="col-lg-2 control-label" style={{marginTop: "20px"}}>Number of
                                        results: {this.state.totalResults}</label>
                                    <div className="col-lg-10">
                                        {this.getPagination()}
                                    </div>
                                </div>
                            </Form>
                        </div>
                    </div>
                    <div className="ibox float-e-margins">
                        <div className="ibox-content table-overflow-x-scroll">
                            <CustomTable isEnabled={() => true}
                                         className="table table-striped table-bordered table-hover dataTables-example dataTable">
                                <thead>
                                <tr role="row">
                                    <th>Game Id</th>
                                    <th>User Id</th>
                                    <th>Players</th>
                                    <th>Cards</th>
                                    <th>Total</th>
                                    <th>Game Status</th>
                                    <th>Game Result</th>
                                    <th>Insured</th>
                                    <th>Double</th>
                                    <th>Split</th>
                                    <th>Currency</th>
                                    <th>Bet</th>
                                    <th>Winnings</th>
                                    <th>Variant</th>
                                    <th>Start Time</th>
                                    <th>End Time</th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.getHands()}
                                </tbody>
                            </CustomTable>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private getCards(cards: string[]): JSX.Element[] {
        return cards.map((card) => {
            return <span
                className={BlackjackHandHistoryListView.isRedCard(card) ? 'blackjack-card-red' : 'blackjack-card-black'}>{card}</span>
        })
    }

    private getHands(): JSX.Element[] {
        return this.state.games.map((game: Game) => {
            return (
                <tr key={game.gameId}>
                    <td>{game.gameId}</td>
                    <td>{game.userId}</td>
                    <td>
                        <div className='blackjack-hand'>Dealer</div>
                        {game.playerHands && game.playerHands.map(() => {
                            return <div className='blackjack-hand'>{game.userId}</div>
                        })}
                    </td>
                    <td>
                        <div className='blackjack-hand'>{game.dealerHand && this.getCards(game.dealerHand.cards)}</div>
                        {game.playerHands && game.playerHands.map((hand: Hand) => {
                            return <div className='blackjack-hand'>{this.getCards(hand.cards)}</div>
                        })}
                    </td>
                    <td>
                        <div className='blackjack-hand'>{game.dealerHand && game.dealerHand.value.toString()}</div>
                        {game.playerHands && game.playerHands.map((hand: Hand) => {
                            return <div className='blackjack-hand'>{hand.value.toString()}</div>
                        })}
                    </td>
                    <td>{game.gameResult}</td>
                    <td>
                        <div className='blackjack-hand'>-</div>
                        {game.playerHands && game.playerHands.map((hand: Hand) => {
                            return <div className='blackjack-hand'>{hand.state}</div>
                        })}
                    </td>
                    <td>{game.isInsured.toString()}</td>
                    <td>
                        <div className='blackjack-hand'>-</div>
                        {game.playerHands && game.playerHands.map((hand: Hand) => {
                            return <div className='blackjack-hand'>{hand.isDoubled.toString()}</div>
                        })}
                    </td>
                    <td>
                        <div className='blackjack-hand'>-</div>
                        {game.playerHands && game.playerHands.map((hand: Hand) => {
                            return <div className='blackjack-hand'>{hand.isSplit.toString()}</div>
                        })}
                    </td>
                    <td>{game.currency}</td>
                    <td>{game.initialBet.toString()}</td>
                    <td>{game.winnings.toString()}</td>
                    <td>{game.variant}</td>
                    <td>{BlackjackHandHistoryListView.formatTimeString(game.startTime)}</td>
                    <td>{BlackjackHandHistoryListView.formatTimeString(game.endTime)}</td>
                </tr>
            );
        });
    }

    private static isRedCard(card: string): boolean {
        return card.indexOf('h') !== -1 || card.indexOf('d') !== -1
    }

    private static formatTimeString(zonedTimeStamp: string): string {
        if (!zonedTimeStamp) return '';
        return moment(zonedTimeStamp, "YYYY-MM-DDTHH:mm:ssZ")
            .tz("UTC")
            .format("YYYY-MM-DD HH:mm:ss UTC")
    }
}


// WEBPACK FOOTER //
// ./src/app/ui/view/blackjack/history/BlackjackHandHistoryListView.tsx